import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { updatePreset } from '@primeuix/themes';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, ToastModule, ButtonModule],
    providers: [MessageService],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent {
    makeIndigo() {
        console.log(
            'Before:',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--p-primary-500'
            )
        );
        updatePreset({
            semantic: {
                primary: {
                    500: '{indigo.500}'
                }
            }
        });
        console.log(
            'After:',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--p-primary-500'
            )
        );
    }

    makeEmerald() {
        console.log(
            'Before:',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--p-primary-500'
            )
        );
        updatePreset({
            semantic: {
                primary: {
                    500: '{emerald.500}'
                }
            }
        });
        console.log(
            'After:',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--p-primary-500'
            )
        );
    }
}
